import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { SharedI18nModule } from '@bizzdesign/shared/i18n';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { TranslateMenuItemsPipe } from '@bizzdesign/shared/pipes';
import { TextOverflowTooltip } from '@bizzdesign/ui-components';
import { BDfontSizeSmall } from '@bizzdesign/styles';
import { type BDMenuItem } from '@bizzdesign/shared/models';
import { Router } from '@angular/router';

@Component({
  selector: 'bd-breadcrumb',
  imports: [
    AsyncPipe,
    BreadcrumbModule,
    SharedI18nModule,
    TranslateMenuItemsPipe,
    TextOverflowTooltip,
  ],
  templateUrl: './breadcrumb.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent {
  @Input() breadcrumbItems: BDMenuItem[] = [];
  @Output() breadcrumbClick: EventEmitter<BDMenuItem> = new EventEmitter();
  fontSize = BDfontSizeSmall;
  private router = inject(Router);

  onItemClick(item: BDMenuItem) {
    if (item.command) {
      item.command({});
    } else if (item.routerLink) {
      this.router.navigateByUrl(item.routerLink, item.routerLinkActiveOptions);
    }
    this.breadcrumbClick.emit(item);
  }
}
